import { IconComputer } from '@components/icons/computer';
import { IconPhone } from '@components/icons/phone';
import { IconTablet } from '@components/icons/tablet';
import { ToggleGroup } from '@components/toggle-group';

import { ViewportType } from './state';

type ViewportActionsProps = {
  selectedViewport: ViewportType;
  onViewportSelect(viewport: ViewportType): void;
};

export const ViewportActions = ({ onViewportSelect, selectedViewport }: ViewportActionsProps) => {
  return (
    <div>
      <ToggleGroup.Root value={selectedViewport} onChange={onViewportSelect}>
        <ToggleGroup.IconButton size="lg" icon={IconComputer} value="desktop" />
        <ToggleGroup.IconButton size="lg" icon={IconTablet} value="tablet" />
        <ToggleGroup.IconButton size="lg" icon={IconPhone} value="mobile" />
      </ToggleGroup.Root>
    </div>
  );
};
